import Radio from "components/atoms/Radio";
import React, { ChangeEvent } from "react";
import "./index.scss";

interface SortProps {
  sort?: string;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Sort: React.FC<SortProps> = ({ sort, handleChange }) => (
  <div className="m-sort">
    <Radio
      type="radio"
      name="SORT"
      value="1"
      display="Bán chạy"
      selected={sort}
      onChange={handleChange}
    />
    <Radio
      type="radio"
      name="SORT"
      value="2"
      display="Giá thấp đến cao"
      selected={sort}
      onChange={handleChange}
    />
    <Radio
      type="radio"
      name="SORT"
      value="3"
      display="Giá cao đến thấp"
      selected={sort}
      onChange={handleChange}
    />
  </div>
);

export default React.memo(Sort);
